import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import firebaseConfigProduction from './firebase.config.production.json';
import firebaseConfigStaging from './firebase.config.staging.json';
import firebaseConfigPentest from './firebase.config.pentest.json';

/**
 * Initialize Firebase app with env-aware config + analytics.
 * Uses staging config for anything other than VITE_ENV=production or
 * VITE_ENV=pentest (the isolated pen-testing project).
 */
export function createFirebaseApp() {
    const firebaseConfig = import.meta.env.VITE_ENV === 'production'
        ? firebaseConfigProduction
        : import.meta.env.VITE_ENV === 'pentest'
            ? firebaseConfigPentest
            : firebaseConfigStaging;

    const firebase = initializeApp(firebaseConfig);

    if (!import.meta.env.DEV && typeof window !== 'undefined') {
        // Analytics init triggers a runtime webConfig fetch + an installations
        // authToken request (~1.5s combined). Neither is needed for first paint,
        // so defer them off the critical path until the browser is idle.
        const initAnalytics = () => {
            isSupported().then((supported) => {
                if (supported) getAnalytics(firebase);
            });
        };
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(initAnalytics);
        } else {
            setTimeout(initAnalytics, 0);
        }
    }

    return firebase;
}
